var exports = {
  "Hc": "QuickCssEditorPanel.module__host___aXRWRl",
  "Gt": "QuickCssEditorPanel.module__frame___aXRWRl",
  "ko": "QuickCssEditorPanel.module__captureLayer___aXRWRl",
  "Uv": "QuickCssEditorPanel.module__dockHandle___aXRWRl",
};

module.exports = exports;
